import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import React from 'react';

import DetailToggleButton from './DetailToggleButton';
import type { Program } from './programs';

interface ProgramMobileCardProps {
	program: Program;
	isOpen: boolean;
	panelId: string;
	onToggle: () => void;
}

const ProgramMobileCard: React.FC<ProgramMobileCardProps> = ({ program, isOpen, panelId, onToggle }) => {
	const { title, theme, chip, detailLabel, detail, stats, notes } = program;

	return (
		<Stack
			alignItems="center"
			gap={isOpen ? '24px' : '8px'}
			padding="16px 20px"
			bgcolor={theme.surface}
			border={`1px solid ${theme.main}`}
			borderRadius="20px"
			overflow="hidden"
			sx={{ wordBreak: 'keep-all' }}
		>
			<Stack alignItems="center" gap="4px" width="100%">
				<Typography fontSize="12px" fontWeight={700} color={theme.main} whiteSpace="nowrap">
					{chip}
				</Typography>
				<Typography fontSize="18px" fontWeight={700} lineHeight="28px" color={theme.main} textAlign="center" whiteSpace="normal">
					{title}
				</Typography>
			</Stack>

			{/* aria-controls 가 항상 실제 노드를 가리키도록 접힌 상태에서도 마운트 유지 */}
			<Stack id={panelId} display={isOpen ? 'flex' : 'none'} gap="16px" width="100%">
				<Stack gap="8px">
					<Stack gap="12px" padding="14px 20px" bgcolor="#FFFFFF" borderRadius="20px">
						<Typography fontSize="14px" fontWeight={700} lineHeight="24px" color={theme.label}>
							{detailLabel}
						</Typography>
						<Stack>
							{detail.map((paragraph, index) => (
								<Typography key={index} fontSize="16px">
									{paragraph}
								</Typography>
							))}
						</Stack>
					</Stack>

					{stats.map(({ label, value }) => (
						<Stack key={label} gap="4px" padding="14px 20px" bgcolor="#FFFFFF" borderRadius="20px">
							<Typography fontSize="14px" lineHeight="24px">
								{label}
							</Typography>
							<Typography fontSize="20px" fontWeight={700} lineHeight="30px">
								{value}
							</Typography>
						</Stack>
					))}
				</Stack>

				<Stack>
					{notes.map((note) => (
						<Typography key={note} fontSize="14px" color="#6F7276">
							{note}
						</Typography>
					))}
				</Stack>
			</Stack>

			<DetailToggleButton isOpen={isOpen} panelId={panelId} onClick={onToggle} />
		</Stack>
	);
};

export default ProgramMobileCard;
